export { default } from './BlogFooter';